export class TrackingQueue {
  constructor(adapter) {
    this.adapter = adapter
    this.queue = []
    this.ready = false
    this.cached = {} // This object will tell us how many times the event was triggered.
  }

  init() {
    return this.adapter.init().then(() => {
      this.ready = true

      while (this.queue.length > 0) {
        const { type, args } = this.queue.shift()
        this.adapter[type](...args)
      }
    })
  }

  trackEvent(...args) {
    if (!this.ready) {
      this.queue.push({ type: 'trackEvent', args })
    } else {
      this.adapter.trackEvent(...args)
    }
  }

  trackEventOnce(...args) {
    const [eventName] = args || []

    const counter = this.cached[eventName] || 0

    if (counter >= 1) {
      // Ignore this track, because we should track it once per session
      return
    }

    this.cached[eventName] = counter + 1

    this.trackEvent(...args)
  }

  identify(...args) {
    if (!this.ready) {
      this.queue.push({ type: 'identify', args })
    } else {
      this.adapter.identify(...args)
    }
  }

  reset(...args) {
    this.cached = {}

    if (!this.ready) {
      this.queue.push({ type: 'reset', args })
    } else {
      this.adapter.reset(...args)
    }
  }
}
